import request from '@/config/axios'

export interface MerchantPlanVO {
  id?: number
  name: string
  level: number
  sort?: number
  price: number
  spuLimit: number
  status: number
  remark?: string
  createTime?: string
  updateTime?: string
}

export const getPlanPage = (params: any) => {
  return request.get({ url: '/merchant/plan/page', params })
}

export const getPlan = (id: number) => {
  return request.get({ url: '/merchant/plan/get', params: { id } })
}

export const createPlan = (data: MerchantPlanVO) => {
  return request.post({ url: '/merchant/plan/create', data })
}

export const updatePlan = (data: MerchantPlanVO) => {
  return request.put({ url: '/merchant/plan/update', data })
}

export const deletePlan = (id: number) => {
  return request.delete({ url: '/merchant/plan/delete', params: { id } })
}
